import React from 'react';

const variants = {
  default: 'bg-gray-100 text-gray-700',
  primary: 'bg-blue-100 text-blue-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-yellow-100 text-yellow-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-cyan-100 text-cyan-700',
};

export function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span
      className={[
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        variants[variant],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}

// Maps analysis status to badge variant
export function StatusBadge({ status }) {
  const map = {
    pending: { variant: 'default', label: 'Queued' },
    processing: { variant: 'info', label: 'Analyzing...' },
    completed: { variant: 'success', label: 'Complete' },
    failed: { variant: 'danger', label: 'Failed' },
    paid: { variant: 'success', label: 'Paid' },
    overdue: { variant: 'danger', label: 'Overdue' },
    active: { variant: 'success', label: 'Active' },
    inactive: { variant: 'default', label: 'Inactive' },
  };
  const { variant = 'default', label = status } = map[status] || {};
  return <Badge variant={variant}>{label}</Badge>;
}

export default Badge;
